import {Action, configureStore, Middleware, ThunkAction} from '@reduxjs/toolkit'
import indexReducer from '@/store/slices'
import storageReducer from '@/store/slices/storage'
import walletReducer from '@/store/slices/wallet'
import pricesReducer from '@/store/slices/prices'
import descriptionsReducer from '@/store/slices/descriptions'
import LocalStorageResolver from '@/services/localStorageResolver'

const localStorageMiddleware: Middleware =
  ({getState}) =>
  (next) =>
  (action) => {
    const result = next(action)
    if (result.type.indexOf('storage/') !== -1) {
      LocalStorageResolver.setStorage(getState().storage)
    }
    return result
  }

const reHydrateStore = () => {
  const storage = LocalStorageResolver.getStorage()
  if (storage !== null) {
    return {
      storage: {
        language: 'en',
        ...storage,
      },
    }
  }
}

export const store = configureStore({
  reducer: {
    index: indexReducer,
    storage: storageReducer,
    wallet: walletReducer,
    prices: pricesReducer,
    descriptions: descriptionsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(localStorageMiddleware),
  preloadedState: reHydrateStore(),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
